import axios from 'axios'

const supportApi = axios.create({
  baseURL: import.meta.env.VITE_API_SUPPORT_URL,
})

supportApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

export default supportApi
